/**
 * HBase Icon — Squircle shape used throughout the app.
 *
 * Fill color can be set via the `color` prop.
 *
 * @example
 * <HBaseIcon size={32} color="#2E1065" />
 *
 * @example
 * <HBaseIcon size={44} color="var(--primary-color)" />
 */
export const HBaseIcon = ({ size = 32, color }: { size?: number; color?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.96 2.27C28.26 0 20.13 0 20.13 0H16H11.87C11.87 0 3.74 0 2.04 2.27C0.41 4.45 0 7.14 0 16C0 24.86 0.41 27.55 2.04 29.73C3.74 32 11.87 32 11.87 32H16H20.13C20.13 32 28.26 32 29.96 29.73C31.59 27.55 32 24.86 32 16C32 7.14 31.59 4.45 29.96 2.27Z"
        fill={color || 'currentColor'}
      />
    </svg>
  )
}
